import { gql } from "@apollo/client";

export const ARCHIVE_CYCLE = gql`
  mutation ArchiveCycle($cycleId: String!) {
    archiveCycle(cycleId: $cycleId) {
      id
    }
  }
`;
